var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"locality-time-line-card"},[_c('p',{staticClass:"h4 text-warning cursor-pointer font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("translation")(_vm.locality.translations,_vm.$i18n.locale, 'title'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }